// extracted by mini-css-extract-plugin
module.exports = {"arrow":"Arrow_arrow__BJClj","disabled":"Arrow_disabled__26mMu","rawArrow":"Arrow_rawArrow__az57x","arrowLeft":"Arrow_arrowLeft__RFNTM","arrowRight":"Arrow_arrowRight__Hl4Dm"};